import styled from 'styled-components';

const Paragraph = styled.p`

`;

export default Paragraph;